import { Routes } from '@angular/router';
import { authGuard, loginGuard, roleGuard } from './guards/auth.guard';
import { UserRoles } from './services/auth.service';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: 'login',
    title: 'Anmeldung',
    loadComponent: () => import('./components/login/login').then(m => m.LoginComponent),
    canActivate: [loginGuard],
  },
  {
    path: 'dashboard',
    title: 'Dashboard',
    loadComponent: () => import('./components/dashboard/dashboard').then(m => m.DashboardComponent),
    canActivate: [authGuard],
  },
  {
    path: 'orders',
    title: 'Aufträge Übersicht',
    loadComponent: () =>
      import('./components/orders/orders-list/orders-list').then(m => m.OrdersListComponent),
    canActivate: [authGuard],
  },
  {
    path: 'orders/new',
    title: 'Neuer Auftrag',
    loadComponent: () =>
      import('./components/orders/order-form/order-form').then(m => m.OrdersFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.ORDER_WRITE] },
  },
  {
    path: 'orders/details/:id',
    title: 'Auftrag Details',
    loadComponent: () =>
      import('./components/orders/order-detail/order-detail').then(m => m.OrderDetailComponent),
    canActivate: [authGuard],
  },
  {
    path: 'orders/:id/edit',
    title: 'Auftrag bearbeiten',
    loadComponent: () =>
      import('./components/orders/order-form/order-form').then(m => m.OrdersFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.ORDER_WRITE] },
  },
  {
    path: 'order-templates',
    title: 'Auftragsvorlagen Übersicht',
    loadComponent: () =>
      import('./components/order-templates/order-templates-list/order-templates-list').then(
        m => m.OrderTemplatesListComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'order-templates/new',
    title: 'Neue Auftragsvorlage',
    loadComponent: () =>
      import('./components/order-templates/order-templates-form/order-templates-form').then(
        m => m.OrderTemplatesFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.ORDER_WRITE] },
  },
  {
    path: 'order-templates/:id/edit',
    title: 'Auftragsvorlage bearbeiten',
    loadComponent: () =>
      import('./components/order-templates/order-templates-form/order-templates-form').then(
        m => m.OrderTemplatesFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.ORDER_WRITE] },
  },
  {
    path: 'maintenance-contracts',
    title: 'Wartungsverträge Übersicht',
    loadComponent: () =>
      import('./components/maintenance-contracts/maintenance-contracts-list/maintenance-contracts-list').then(
        m => m.MaintenanceContractsListComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'maintenance-contracts/new',
    title: 'Neuer Wartungsvertrag',
    loadComponent: () =>
      import('./components/maintenance-contracts/maintenance-contract-form/maintenance-contract-form').then(
        m => m.MaintenanceContractFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'maintenance-contracts/:id/edit',
    title: 'Wartungsvertrag bearbeiten',
    loadComponent: () =>
      import('./components/maintenance-contracts/maintenance-contract-form/maintenance-contract-form').then(
        m => m.MaintenanceContractFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'weekly-view',
    title: 'Wochenansicht',
    loadComponent: () =>
      import('./components/weekly-view/weekly-view').then(m => m.WeeklyViewComponent),
    canActivate: [authGuard],
  },
  {
    path: 'measurements',
    title: 'Einheiten',
    loadComponent: () =>
      import('./components/measurements/measurements-list/measurements-list').then(
        m => m.MeasurementsListComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'measurements/new',
    title: 'Neue Einheit',
    loadComponent: () =>
      import('./components/measurements/measurement-form/measurement-form').then(
        m => m.MeasurementFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'measurements/:id/edit',
    title: 'Einheit bearbeiten',
    loadComponent: () =>
      import('./components/measurements/measurement-form/measurement-form').then(
        m => m.MeasurementFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'appointment-types',
    title: 'Terminarten',
    loadComponent: () =>
      import('./components/appointment-types/appointment-types-list/appointment-types-list').then(
        m => m.AppointmentTypesListComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'appointment-types/new',
    title: 'Neue Terminart',
    loadComponent: () =>
      import('./components/appointment-types/appointment-type-form/appointment-type-form').then(
        m => m.AppointmentTypeFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'appointment-types/:id/edit',
    title: 'Terminart bearbeiten',
    loadComponent: () =>
      import('./components/appointment-types/appointment-type-form/appointment-type-form').then(
        m => m.AppointmentTypeFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'avv',
    title: 'AVV-Verzeichnis',
    loadComponent: () => import('./components/avv/avv-list/avv-list').then(m => m.AVVListComponent),
    canActivate: [authGuard],
  },
  {
    path: 'avv/new',
    title: 'Neuer AVV-Eintrag',
    loadComponent: () => import('./components/avv/avv-form/avv-form').then(m => m.AVVFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'avv/:id/edit',
    title: 'AVV-Eintrag bearbeiten',
    loadComponent: () => import('./components/avv/avv-form/avv-form').then(m => m.AVVFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'employees',
    title: 'Mitarbeiter Übersicht',
    loadComponent: () =>
      import('./components/employees/employees-list/employees-list').then(
        m => m.EmployeesListComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.EMPLOYEE_READ, UserRoles.EMPLOYEE_WRITE] },
  },
  {
    path: 'employees/new',
    title: 'Neuer Mitarbeiter',
    loadComponent: () =>
      import('./components/employees/employee-form/employee-form').then(
        m => m.EmployeeFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.EMPLOYEE_WRITE] },
  },
  {
    path: 'employees/:id/edit',
    title: 'Mitarbeiter bearbeiten',
    loadComponent: () =>
      import('./components/employees/employee-form/employee-form').then(
        m => m.EmployeeFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.EMPLOYEE_WRITE] },
  },
  {
    path: 'employee-absences',
    title: 'Abwesenheitskalender',
    loadComponent: () =>
      import('./components/employees/employee-absences-calendar/employee-absences-calendar').then(
        m => m.EmployeeAbsencesCalendarComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.EMPLOYEE_READ, UserRoles.EMPLOYEE_WRITE] },
  },
  {
    path: 'users',
    title: 'Benutzer',
    loadComponent: () =>
      import('./components/users/users-list/users-list').then(m => m.UsersListComponent),
    canActivate: [authGuard],
  },
  // {
  //   path: 'users/new',
  //   title: 'Neuer Benutzer',
  //   loadComponent: () =>
  //     import('./components/users/user-form/user-form').then(m => m.UserFormComponent),
  //   canActivate: [roleGuard],
  //   data: { roles: [UserRoles.MASTERDATA_WRITE] },
  // },
  // {
  //   path: 'users/:id/edit',
  //   title: 'Benutzer bearbeiten',
  //   loadComponent: () =>
  //     import('./components/users/user-form/user-form').then(m => m.UserFormComponent),
  //   canActivate: [roleGuard],
  //   data: { roles: [UserRoles.MASTERDATA_WRITE] },
  // },
  {
    path: 'vehicles',
    title: 'Technische Betriebsmittel',
    loadComponent: () =>
      import('./components/vehicles/vehicles-list/vehicles-list').then(
        m => m.VehiclesListComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'vehicles/new',
    title: 'Neues technisches Betriebsmittel',
    loadComponent: () =>
      import('./components/vehicles/vehicle-form/vehicle-form').then(m => m.VehicleFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'vehicles/:id/edit',
    title: 'Technisches Betriebsmittel bearbeiten',
    loadComponent: () =>
      import('./components/vehicles/vehicle-form/vehicle-form').then(m => m.VehicleFormComponent),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'service-items',
    title: 'Leistungen',
    loadComponent: () =>
      import('./components/service-items/service-items-list/service-items-list').then(
        m => m.ServiceItemsListComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'service-items/new',
    title: 'Neue Leistung',
    loadComponent: () =>
      import('./components/service-items/service-item-form/service-item-form').then(
        m => m.ServiceItemFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'service-items/:id/edit',
    title: 'Leistung bearbeiten',
    loadComponent: () =>
      import('./components/service-items/service-item-form/service-item-form').then(
        m => m.ServiceItemFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'revenue-accounts',
    title: 'Erlöskonten',
    loadComponent: () =>
      import('./components/revenue-accounts/revenue-accounts-list/revenue-accounts-list').then(
        m => m.RevenueAccountsListComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'revenue-accounts/new',
    title: 'Neues Erlöskonto',
    loadComponent: () =>
      import('./components/revenue-accounts/revenue-account-form/revenue-account-form').then(
        m => m.RevenueAccountFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'revenue-accounts/:id/edit',
    title: 'Erlöskonto bearbeiten',
    loadComponent: () =>
      import('./components/revenue-accounts/revenue-account-form/revenue-account-form').then(
        m => m.RevenueAccountFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'framework-contracts',
    title: 'Rahmenverträge Übersicht',
    loadComponent: () =>
      import('./components/framework-contracts/framework-contracts-list/framework-contracts-list').then(
        m => m.FrameworkContractsListComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.CONTRACTS_WRITE, UserRoles.CONTRACTS_READ] },
  },
  {
    path: 'framework-contracts/new',
    title: 'Neuer Rahmenvertrag',
    loadComponent: () =>
      import('./components/framework-contracts/framework-contract-form/framework-contract-form').then(
        m => m.FrameworkContractFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.CONTRACTS_WRITE, UserRoles.CONTRACTS_READ] },
  },
  {
    path: 'framework-contracts/:id/edit',
    title: 'Rahmenvertrag bearbeiten',
    loadComponent: () =>
      import('./components/framework-contracts/framework-contract-form/framework-contract-form').then(
        m => m.FrameworkContractFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.CONTRACTS_WRITE, UserRoles.CONTRACTS_READ] },
  },
  {
    path: 'waste-notifications',
    title: 'Notifizierungen',
    loadComponent: () =>
      import('./components/waste-notifications/waste-notifications-list/waste-notifications-list').then(
        m => m.WasteNotificationsListComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'waste-notifications/new',
    title: 'Neue Notifizierung',
    loadComponent: () =>
      import('./components/waste-notifications/waste-notification-form/waste-notification-form').then(
        m => m.WasteNotificationFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'waste-notifications/:id/edit',
    title: 'Notifizierung bearbeiten',
    loadComponent: () =>
      import('./components/waste-notifications/waste-notification-form/waste-notification-form').then(
        m => m.WasteNotificationFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'reports',
    title: 'Berichte',
    loadComponent: () =>
      import('./components/reports/reports-overview/reports-overview').then(
        m => m.ReportsOverviewComponent
      ),
    canActivate: [authGuard],
    data: { roles: [UserRoles.REPORTS_READ] },
  },
  {
    path: 'reports/revenue-accounts',
    title: 'Bericht: Erlöskonten',
    loadComponent: () =>
      import('./components/reports/revenue-account-report/revenue-account-report').then(
        m => m.RevenueAccountReportComponent
      ),
    canActivate: [authGuard],
    data: { roles: [UserRoles.REPORTS_READ] },
  },
  {
    path: 'reports/revenue-account-summary',
    title: 'Bericht: Erlöskonten-Zusammenfassung',
    loadComponent: () =>
      import('./components/reports/revenue-account-summary-report/revenue-account-summary-report').then(
        m => m.RevenueAccountSummaryReportComponent
      ),
    canActivate: [authGuard],
    data: { roles: [UserRoles.REPORTS_READ] },
  },
  {
    path: 'reports/service-items-revenue',
    title: 'Bericht: Leistungen & Erlöskonten',
    loadComponent: () =>
      import('./components/reports/service-items-revenue-report/service-items-revenue-report').then(
        m => m.ServiceItemsRevenueReportComponent
      ),
    canActivate: [authGuard],
    data: { roles: [UserRoles.REPORTS_READ] },
  },
  {
    path: 'reports/order-service-items',
    title: 'Bericht: Auftrags- & Leistungsauswertung',
    loadComponent: () =>
      import('./components/reports/order-service-items-report/order-service-items-report').then(
        m => m.OrderServiceItemsReportComponent
      ),
    canActivate: [authGuard],
    data: { roles: [UserRoles.REPORTS_READ] },
  },
  {
    path: 'contacts',
    title: 'Kontakte',
    loadComponent: () =>
      import('./components/contacts/contacts-list').then(m => m.ContactsListComponent),
    canActivate: [authGuard],
  },
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];
